import { render, staticRenderFns } from "./EwptxPreSaleSection.vue?vue&type=template&id=477b6e8a&"
import script from "./EwptxPreSaleSection.vue?vue&type=script&lang=js&"
export * from "./EwptxPreSaleSection.vue?vue&type=script&lang=js&"
import style0 from "./EwptxPreSaleSection.vue?vue&type=style&index=0&id=477b6e8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports